// extracted by mini-css-extract-plugin
module.exports = {"skip_link":"skip_to_content_skip_link__NY7v_"};